<template>
    <div class="tabletBody message_line">
        <div class="container">
            <div class="row">
                <div class="align-items-center d-flex flex-wrap h-100 justify-content-between position-absolute text-center thank_you">
                    <div class="d-flex flex-column kaz w-100">
                        <span class="thnx" style="font-size: 50px">Өтінемін, 15 минут күтіңіз</span>
                        <span class="desc" style="font-size: 48px">Маман клиентке қызмет көрсетеді</span>
                    </div>
                    <div class="d-flex flex-column rus w-100">
                        <span class="thnx" style="font-size: 50px">Пожалуйста, подождите 15 минут</span>
                        <span class="desc" style="font-size: 48px">Специалист обслуживает клиента</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pausePage"
    }
</script>
